import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation, generatePath } from "react-router-dom";
import {
  fetchAffiliate,
  initializeAffiliateScreen,
  setDeleteConfirmationPopupVisibility,
  exportAffiliate,
  saveAffiliateTableState,
} from "../../../redux/actions/Affiliate/affiliate";
import { emailAffiliateReport, fetchAffiliateLocationDD, fetchAffiliateNetworkDD, clearAffiliateEmailDropdowns } from "../../../redux/actions/Affiliate/affiliateReport";
import { fetchLocationDD } from "../../../redux/actions/location";
import { fetchRateAdminNetworksDD } from "../../../redux/actions/RateAdmin/rateadminNetworks";
import Affiliate from "../../../component/Affiliate/Affiliate";
import { loadingShow } from "../../../services/PostAPI";
import { APP_URLS } from "../../../utils/constant";
import { FILTER } from "../../../services/common/urlService";

function AffiliateScreen(props) {
  const {
    fetchAffiliate,
    initAffiliateScreen,
    showPageLevelLoader,
    affiliateListview,
    paginationInfo,
    exportAffiliate,
    emailAffiliateReport,
    isAffiliateExportError,
    isAffiliateExportSuccess,
    isEmailSending,
    screenPermissions,
    isLoading,
    savedTableState,
    saveAffiliateTableState,
    fetchLocationDD,
    fetchNetworkDD,
    locationDD,
    networkDD,
    fetchAffiliateLocationDD,
    fetchAffiliateNetworkDD,
    clearAffiliateEmailDropdowns,
    affiliateLocationDD,
    affiliateNetworkDD,
    isLoadingAffiliateDD,
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;

    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach((key) => {
        if (
          key !== "global" &&
          state.filters[key]?.value !== null &&
          state.filters[key]?.value !== undefined
        ) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: filterValue,
          });
        }
      });
    }

    return {
      sortField: state.sortField || "id",
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined,
      userId: localStorage.getItem("userId"),
    };
  };

  useEffect(() => {
    fetchLocationDD();
    fetchNetworkDD();

    const statusFilter = location.state?.statusFilter;

    if (statusFilter) {
      initAffiliateScreen();
      fetchAffiliate({
        sortField: "id",
        userId: localStorage.getItem("userId"),
        filters: [
          {
            filterField: "status",
            matchStrategy: FILTER.MATCH_STRATEGY.CONTAINS,
            query: statusFilter,
          },
        ],
      });
      return;
    }

    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);

    if (savedParams) {
      fetchAffiliate(savedParams);
    } else {
      initAffiliateScreen();
      fetchAffiliate({ sortField: "id", userId: localStorage.getItem("userId") });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    let newPayload = {
      ...props,
      userId: localStorage.getItem("userId"),
    };
    fetchAffiliate(newPayload);
  };

  const handleTableStateChange = (tableState) => {
    saveAffiliateTableState(tableState);
  };

  const handleCreateAffiliate = () => {
    navigate(APP_URLS.AFFILIATE.CREATE);
  };

  const editAffiliateRoute = (id) => {
    const path = generatePath(APP_URLS.AFFILIATE.EDIT, { id });
    navigate(path);
  };

  const affiliateProps = {
    handleCreateAffiliate,
    exportAffiliate,
    emailAffiliateReport,
    isAffiliateExportError,
    isAffiliateExportSuccess,
    isEmailSending,
    editAffiliateRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchAffiliates: loadLazyData,
    tableData: {
      columns: affiliateListview?.columns,
      rows: affiliateListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
    locationDD,
    networkDD,
    fetchAffiliateLocationDD,
    fetchAffiliateNetworkDD,
    clearAffiliateEmailDropdowns,
    affiliateLocationDD,
    affiliateNetworkDD,
    isLoadingAffiliateDD,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");

  return (
    <div>
      <Affiliate {...affiliateProps} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    initAffiliateScreen: () => dispatch(initializeAffiliateScreen()),
    fetchAffiliate: (payload) => dispatch(fetchAffiliate(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportAffiliate: (payload) => dispatch(exportAffiliate(payload)),
    emailAffiliateReport: (payload) => dispatch(emailAffiliateReport(payload)),
    saveAffiliateTableState: (payload) => dispatch(saveAffiliateTableState(payload)),
    fetchLocationDD: (payload) => dispatch(fetchLocationDD(payload)),
    fetchNetworkDD: (payload) => dispatch(fetchRateAdminNetworksDD(payload)),
    fetchAffiliateLocationDD: (affiliateId) => dispatch(fetchAffiliateLocationDD(affiliateId)),
    fetchAffiliateNetworkDD: (affiliateId) => dispatch(fetchAffiliateNetworkDD(affiliateId)),
    clearAffiliateEmailDropdowns: () => dispatch(clearAffiliateEmailDropdowns()),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    affiliateListview: selectAffiliatesList(state.affiliateReducer),
    showPageLevelLoader: selectIsLoadingPage(state.affiliateReducer),
    paginationInfo: selectPaginationInfo(state.affiliateReducer),
    isPageLevelError: selectIsPageLevelError(state.affiliateReducer),
    isFetchingGridData: selectIsLoading(state.affiliateReducer),
    isAffiliateExportError: selectIsAffiliateExportError(state.affiliateReducer),
    isAffiliateExportSuccess: selectIsAffiliateExportSuccess(state.affiliateReducer),
    isEmailSending: selectIsEmailSending(state.affiliateReportReducer),
    savedTableState: state.affiliateReducer?.savedTableState,
    locationDD: selectFromLocationReducer(state, "locationDD"),
    networkDD: selectFromNetworkReducer(state, "NetworksDD"),
    affiliateLocationDD: state.affiliateReportReducer?.affiliateLocationDD || [],
    affiliateNetworkDD: state.affiliateReportReducer?.affiliateNetworkDD || [],
    isLoadingAffiliateDD: state.affiliateReportReducer?.isLoadingAffiliateDD,
  };
};

const selectIsAffiliateExportError = (affiliateReducer) =>
  affiliateReducer?.isAffiliateExportError;
const selectIsAffiliateExportSuccess = (affiliateReducer) =>
  affiliateReducer?.isAffiliateExportSuccess;
const selectIsLoading = (affiliateReducer) => affiliateReducer?.isLoading;
const selectPaginationInfo = (affiliateReducer) => affiliateReducer?.paginationInfo;
const selectIsLoadingPage = (affiliateReducer) => affiliateReducer?.isLoadingPage;
const selectIsPageLevelError = (affiliateReducer) => affiliateReducer?.isPageLevelError;
const selectAffiliatesList = (affiliateReducer) => affiliateReducer?.affiliateListview;
const selectIsEmailSending = (affiliateReportReducer) => affiliateReportReducer?.isEmailSending;

const selectFromLocationReducer = (state, path) => {
  return state.locationReducer?.[path];
};

const selectFromNetworkReducer = (state, path) => {
  return state.rateadminNetworksReducer?.[path];
};

export default connect(mapStateToProps, mapDispatchToProps)(AffiliateScreen);
